import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { SubGroup } from "src/app/shared/interfaces/orgadmin/course-organization";
import { Package } from "src/app/shared/interfaces/packages/package";
import { Guid } from "src/app/shared/types/guid";

export const coursePrefix = "[Package List]";

const packageListActions = {
  reset: `${coursePrefix} Reset`,
  request: `${coursePrefix} Load`,
  requestSingle: `${coursePrefix} Load single`,
  requestActiveSuccess: `${coursePrefix} Load success`,
  requestFail: `${coursePrefix} Load fail`,
  updateSubgroup: `${coursePrefix} Update subgroup`,
  deleteSubgroup: `${coursePrefix} Delete`,
};

export const packageListLoad = createAction(
  packageListActions.request,
  props<{
    id: string;
  }>(),
);

export const packageLoad = createAction(
  packageListActions.requestSingle,
  props<{ packageId: Guid; organizationId: Guid }>(),
);

export const packageListReset = createAction(packageListActions.reset);

export const packageUpdateSubgroup = createAction(
  packageListActions.updateSubgroup,
  props<{ packageId: Guid; courseId: Guid; subgroup: SubGroup }>(),
);

export const packageListLoadSuccess = createAction(
  packageListActions.requestActiveSuccess,
  props<{ packages: Package[] }>(),
);

export const loadPackageListFailure = createAction(
  packageListActions.requestFail,
  props<{ error: HttpErrorResponse }>(),
);

export const packageDeleteSubgroup = createAction(
  packageListActions.deleteSubgroup,
  props<{ packageId: Guid; subgroupId: Guid }>(),
);
